/* global _ */
import 'whatwg-fetch';

export function loadCandidates() {
  return fetch('data/candidates.json')
    .then(r => r.json())
    .then(parseCandidates)
    .then(groupCandidates);
}

function parseCandidates(candidates) {
  return candidates.map(parseCandidate);
}

function parseCandidate(candidate) {
  let { firstName, lastName } = candidate;
  let keys = Object.keys(candidate);
  keys.forEach(transformIssueKey.bind(null, candidate));
  candidate.image = `assets/images/candidates/${firstName.toLowerCase()}_${lastName.toLowerCase()}.png`;
  return candidate;
}

function transformIssueKey(candidate, key) {
  if (/issue/.test(key)) {
    let found = key.match(/issue(\w+)/);
    if (found.length) {
      let newKey = found[1];
      switch(newKey) {
      case 'EconomyJobs':
        newKey = 'jobs';
        break;
      case 'PropertyTaxes':
        newKey = 'taxes';
        break;
      case 'Transportation':
        newKey = 'transit';
        break;
      case 'PlannedParenthood':
        newKey = 'plannedParenthood';
        break;
      default:
        newKey = newKey.toLowerCase();
        break;
      }
      candidate[newKey] = candidate[key];
      delete candidate[key];
    }
  }
}

function groupCandidates(candidates) {
  let { R, D } = _.groupBy(candidates, 'party');
  R = _.sortBy(R, 'lastName');
  D = _.sortBy(D, 'lastName');
  return R.concat(D);
}



// WEBPACK FOOTER //
// ./app/candidates.js